module.exports = __webpack_public_path__ + "img/logo.015cd84f.png";